import { Routes, Route, Navigate } from "react-router-dom";
import LayoutDashboard from "../layout/layout";
import Login from "../pages/Auth/login/login";
import PrivateRoute from "./private-route";

const Navigation = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      {/* Redirect root path to /user-list if authenticated */}
      <Route path="/" element={<Navigate to="/mother-list" replace />} />

      <Route
        path="/*"
        element={
          <PrivateRoute>
            <LayoutDashboard />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default Navigation;
